<nz-upload class="gapping" [nzDisabled]="disabled || readonly" [nzCustomRequest]="handleUpload" [nzShowUploadList]="false">
  <button nz-button type="button" [nzSize]="size">
    <ng-content></ng-content>
  </button>
</nz-upload>
